<template>
    <div class="new-journal">
        <HeaderNewCopy />
        <!-- Desktop -->
        <div class="pc landing-invest">
            <div class="main">
                <div class="main-info">
                    <h1 class="title">Откройте <br>мир инвестиций по-новому вместе с Финсайт</h1>
                    <p class="text"> Получите доступ к самой актуальной и проверенной информации</p>
                    <form class="enter-form-invest" autocomplete="_off">
                        <div class="input-containers" :class="{
                            'input-containers-error': response.type === 'error',
                            'input-containers-success': response.type === 'success',
                        }">
                            <input type="tel" v-model="phone" placeholder="+7 999 123 45 67" v-mask="'+7 ### ### ## ##'"
                                class="text-input">

                            <ButtonAction class="main-action-btn" type="submit" message="Получить доступ"
                                @buttonAction="handleSubmit" />
                        </div>
                    </form>
                </div>
                <div class="img-background">
                    <div class="img-invest"></div>
                </div>
            </div>

            <div class="products">
                <h2 class="sub-title">Наши специалисты ежедневно изучают события, <br />
                    влияющие на фондовые рынки, и делятся ими с вами</h2>
                <div class="product_cards">
                    <div class="product_card">
                        <img src="@/assets/img/landing-invest-news.svg" alt="news">
                        <h4 class="title">Новости</h4>
                        <p class="text">Узнавайте первыми о значимых событиях для фондового рынка</p>
                    </div>
                    <div class="product_card">
                        <img src="@/assets/img/landing-invest-reviews.svg" alt="reviews">
                        <h4 class="title">Обзоры</h4>
                        <p class="text">Исследуйте интересные активы и прогнозы их поведения</p>
                    </div>
                    <div class="product_card">
                        <img src="@/assets/img/landing-invest-ideas.svg" alt="ideas">
                        <h4 class="title">Идеи</h4>
                        <p class="text">Берите на вооружение мысли опытных инвесторов</p>
                    </div>
                    <div class="product_card">
                        <img src="@/assets/img/landing-invest-strategies.svg" alt="strategies">
                        <h4 class="title">Стратегии</h4>
                        <p class="text">Применяйте различные техники управления вложениями</p>
                    </div>
                </div>
            </div>

            <div class="banner">
                <div class="banner-info">
                    <h2 class="sub-title">Получайте ценные сведения и принимайте <br />
                        взвешенные решения, как и куда вложить свои средства <img
                            src="@/assets/img/landing-invest-banner-mark.svg" alt="mark" /></h2>
                    <form class="enter-form-invest" autocomplete="_off">
                        <div class="input-containers" :class="{
                            'input-containers-error': response.type === 'error',
                            'input-containers-success': response.type === 'success',
                        }">
                            <input type="tel" v-model="phone" placeholder="+7 999 123 45 67" v-mask="'+7 ### ### ## ##'"
                                class="text-input" :class="{ 'input-success': phone.length === 16 }">
                            <ButtonAction class="main-action-btn" type="submit" message="Получить доступ"
                                @buttonAction="handleSubmit" />
                        </div>
                    </form>
                </div>
                <div class="banner-img">
                </div>
            </div>
        </div>

        <!--Mobile -->
        <div class="phone landing-invest">
            <div class="main">
                <div class="main-info">
                    <h1 class="title">Откройте <br />мир инвестиций <br />по-новому вместе <br /> с Финсайт</h1>
                    <p class="text"> Получите доступ к самой актуальной <br />и проверенной информации</p>
                    <form class="enter-form-invest" autocomplete="_off">
                        <div class="input-containers" :class="{
                            'input-containers-error': response.type === 'error',
                            'input-containers-success': response.type === 'success',
                        }">
                            <input type="tel" v-model="phone" placeholder="+7 999 123 45 67" v-mask="'+7 ### ### ## ##'"
                                class="text-input">

                            <ButtonAction class="main-action-btn" type="submit" message="Получить доступ"
                                @buttonAction="handleSubmit" />
                        </div>
                    </form>
                </div>
                <div class="img-invest"></div>
            </div>

            <div class="products">
                <h2 class="sub-title">Наши специалисты ежедневно изучают события,
                    влияющие <br />на фондовые рынки, и делятся ими с вами</h2>
                <div class="product_cards">
                    <div class="product_card">
                        <img src="@/assets/img/landing-invest-news.svg" alt="news">
                        <h4 class="title">Новости</h4>
                        <p class="text">Узнавайте первыми о значимых событиях для фондового рынка</p>
                    </div>
                    <div class="product_card">
                        <img src="@/assets/img/landing-invest-reviews.svg" alt="reviews">
                        <h4 class="title">Обзоры</h4>
                        <p class="text">Исследуйте интересные активы <br />и прогнозы их поведения</p>
                    </div>
                    <div class="product_card">
                        <img src="@/assets/img/landing-invest-ideas.svg" alt="ideas">
                        <h4 class="title">Идеи</h4>
                        <p class="text">Берите на вооружение мысли опытных инвесторов</p>
                    </div>
                    <div class="product_card">
                        <img src="@/assets/img/landing-invest-strategies.svg" alt="strategies">
                        <h4 class="title">Стратегии</h4>
                        <p class="text">Применяйте различные техники управления вложениями</p>
                    </div>
                </div>
            </div>

            <div class="banner">
                <div class="banner-info">
                    <h2 class="sub-title">Получайте ценные сведения<br />и принимайте <br />
                        взвешенные решения, как<br /> и куда вложить свои средства <img
                            src="@/assets/img/landing-invest-banner-mark.svg" alt="mark" /></h2>
                    <form class="enter-form-invest" autocomplete="_off">
                        <div class="input-containers" :class="{
                            'input-containers-error': response.type === 'error',
                            'input-containers-success': response.type === 'success',
                        }">
                            <input type="tel" v-model="phone" placeholder="+7 999 123 45 67" v-mask="'+7 ### ### ## ##'"
                                class="text-input">

                            <ButtonAction class="main-action-btn" type="submit" message="Получить доступ"
                                @buttonAction="handleSubmit" />
                        </div>
                    </form>
                </div>
                <div class="banner-img">
                </div>
            </div>
        </div>

        <FooterAgreement @setAgree="isAgree" />
        <div class="notpersonal-advice">
            <img src="@/assets/img/landing-invest-banner-mark-mini.svg" alt="mark">
            <p>Любые сведения, указанные в Статьях, носят исключительно рекомендательный характер и нацелены на оказание
                помощи Пользователям Сервиса в получении необходимой справочной информации. Администрация Сервиса не
                несет ответственности за убыток или ущерб, включая, в частности, любую утрату выгоды, которая может
                являться прямым или косвенным результатом использования или принятия во внимание такой информации. Не
                является индивидуальной инвестиционной рекомендацией.</p>
        </div>
    </div>
</template>
  
<script>
import HeaderNewCopy from '@/components/newRedesign/HeaderNewCopy.vue';
import FooterAgreement from '@/components/newRedesign/UI/FooterAgreement.vue';
import ButtonAction from "@/components/newRedesign/UI/ButtonAction";

export default {
    name: 'Consultations',
    data: () => {
        return {
            phone: '',
            response: false,
            agreement: true,
        }
    },
    components: {
        HeaderNewCopy,
        FooterAgreement,
        ButtonAction,
    },
    watch: {
        phone: function () {
            this.response = false;
        },

    },
    async created() {
        if (this.$store.state.user)
            this.phone = this.$store.state.user.phone.formatted;
    },

    methods: {
        async handleSubmit() {
            let phone = this.phone.replace(/\s|\(|\)|-/g, '');
            if (!this.agreement) {
                this.response = {
                    message: 'Примите соглашение',
                    type: 'error'
                };
                return false;
            }

            if (phone.length !== 12) {
                this.response = { type: 'error' };
                return false;
            } else if (phone.length === 12) {
                this.response = { type: 'success' };
                this.$router.push({
                    name: 'promo-invest',
                    params: {
                        activateTele2: true,
                        phone
                    }
                });
                return false;
            }
        },
        isAgree(agree) {
            this.agreement = agree
        }
    }
}

</script>
  
<style scoped lang="scss">
.landing-invest {
    width: 1232px;
    margin-right: auto;
    margin-left: auto;
    margin-top: 143px;

    .main {
        display: flex;
        justify-content: space-between;
        margin-bottom: 120px;

        .main-info {
            padding: 30px 28px 41px;
            width: 712px;
            background: #F2F2F2;
            border-radius: 12px;

            .title {
                margin-bottom: 118px;
                font-style: normal;
                font-weight: 600;
                font-size: 48px;
                line-height: 57px;
                color: #333333;
            }

            .text {
                margin-bottom: 21px;
                font-family: 'Gilroy';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 19px;
                color: #000000;
            }

        }

        .img-background {
            position: relative;
            width: 504px;
            background: #F2F2F2;
            border-radius: 12px;

            .img-invest {
                background-image: url("../../../assets/img/banner_invest.webp");
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
                width: 416px;
                height: 464px;
                position: absolute;
                top: 35px;
                left: 50px;
            }
        }
    }

    .products {
        margin-bottom: 120px;

        .sub-title {
            margin-bottom: 35px;
            width: 703px;
            font-family: 'Gilroy';
            font-style: normal;
            font-weight: 600;
            font-size: 28px;
            line-height: 33px;
            color: #333333;
        }

        .product_cards {
            display: flex;
            justify-content: space-between;

            .product_card {
                width: 296px;
                height: 226px;
                padding: 30px 20px;
                border-radius: 12px;
                box-shadow: 0px 5px 35px rgba(0, 0, 0, 0.1);

                img {
                    margin-bottom: 32px;
                }

                .title {
                    margin-bottom: 20px;
                    padding: 0;
                    font-family: 'Gilroy';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 20px;
                    line-height: 24px;
                    color: #2F80ED;
                }

                .text {
                    font-family: 'Gilroy';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 20px;
                    color: #333333;
                }
            }
        }
    }

    .banner {
        position: relative;
        margin-bottom: 120px;
        padding: 40px 20px;
        background: #F2F2F2;
        border-radius: 12px;

        .banner-info {}

        .banner-img {
            background-image: url('../../../assets/img/landing-invest-banner.png');
            background-size: contain;
            width: 285px;
            height: 252px;
            position: absolute;
            bottom: -10px;
            right: 10px;

        }
    }

    .sub-title {
        margin-bottom: 35px;
        font-family: 'Gilroy';
        font-style: normal;
        font-weight: 600;
        font-size: 28px;
        line-height: 33px;
        color: #333333;
    }

    .input-containers {
        width: 656px;
        display: flex;
        justify-content: space-between;

        .text-input {
            width: 100%;
            margin-right: 20px;
            padding: 14px;
            text-align: center;
            border-radius: 8px;
            border: 1px solid #BDBDBD;
            outline: none;
            background-color: transparent;
            font-family: Gilroy;
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 19px;
            color: #333333;
            background: #FFFFFF;
        }

        .text-input.input-success {
            border: 1px solid #22B491;
        }

        .text-input::placeholder {
            color: #bdbdbd;
        }
    }

    .input-containers-error {
        .text-input {
            border: 1px solid #CF2F38
        }

        .main-action-btn {
            background: #BDBDBD;
        }
    }

    .input-containers-success {
        .text-input {
            border: 1px solid #22B491;
        }
    }


}

.notpersonal-advice {
    margin: 0 auto 40px;
    display: flex;
    width: 100%;
    max-width: 830px;
    position: relative;
    text-align: center;
    font-family: 'Circe';
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;
    color: #828282;

    img {
        position: absolute;
        top: 0;
        left: 10px;
    }
}
</style>
  
<style scoped lang="scss">
.phone.landing-invest {
    width: 288px;
    margin-top: 177px;

    .main {
        margin-left: calc((100vw - 289px) / -2);
        margin-bottom: 30px;
        width: 100vw;
        position: relative;
        background: #F2F2F2;

        .main-info {
            padding: 20px 0 30px;
            margin: auto;
            width: 289px;

            .title {
                padding: 0;
                margin-bottom: 42px;
                font-size: 27px;
                line-height: 30px;
            }

            .text {
                margin-bottom: 8px;
                font-size: 12px;
                line-height: 14px;
            }

        }

        .img-invest {
            background-image: url("../../../assets/img/banner_invest-mob.webp");
            background-size: cover;
            width: 76px;
            height: 140px;
            position: absolute;
            top: 0;
            right: 0;
        }

    }

    .products {
        margin-bottom: 30px;

        .product_cards {
            display: block;

            .product_card {
                width: 100%;
                height: 137px;
                padding: 30px 30px 40px;
                margin-bottom: 20px;
                position: relative;
                border: 1px solid #F2F2F2;
                box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.2);

                img {
                    width: 30px;
                    height: 30px;
                    position: absolute;
                    top: 20px;
                    right: 20px;
                }

                .title {
                    margin-bottom: 10px;
                    font-size: 18px;
                    line-height: 21px;
                }

                .text {
                    font-size: 14px;
                    line-height: 18px;
                }
            }

            .product_card:last-child {
                margin-bottom: 0;
            }
        }
    }

    .banner {
        margin-left: calc((100vw - 289px) / -2);
        margin-bottom: 40px;
        width: 100vw;
        padding: 0;
        position: relative;

        .banner-info {
            padding: 30px 0;
            margin: auto;
            width: 289px;
        }

        .banner-img {
            display: none;

        }
    }

    .sub-title {
        margin-bottom: 20px;
        width: 100%;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
    }

    .input-containers {
        display: block;
        width: 100%;

        .text-input {
            width: 100%;
            margin: 0;
            margin-bottom: 18px;
            font-size: 14px;
            line-height: 16px;
        }

        .button {
            padding: 12px;
        }
    }
}

@media screen and (max-width: 650px) {
    .notpersonal-advice {
        padding-left: 5px;
        width: 288px;
        font-size: 8px;
        line-height: 11px;

        img {
            left: 0;
        }
    }
}
</style>
  